import { render } from "./HeroCards.vue?vue&type=template&id=5033984a"
import script from "./HeroCards.vue?vue&type=script&lang=js"
export * from "./HeroCards.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__